import axios from "axios";
import config from "../config/config";
import { apiHelper } from "../utils/apiHelper";

const _endpoint = `/api/auth/2fa`;

export const twoFAApi = {
  // Requires active session — uses apiHelper for consistent error handling.
  // Re-throws only for 400/422 (validation) so callers can show field errors;
  // for all other cases apiHelper navigates away and we do not re-throw to
  // avoid triggering a second error update on an already-unmounted component.
  setup: () =>
    axios(`${_endpoint}/setup`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
    })
      .then((result) => result.data)
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 400 || status === 422) {
          throw err;
        }
        apiHelper.handleError(err);
      }),

  // Called during login flow (no auth cookie yet) — errors propagate to the
  // caller's try/catch. Network errors (no response object) fall back to the
  // generic message shown in TwoFAForm; this is intentional behavior.
  verify: (data) =>
    axios(`${_endpoint}/verify`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data,
    }).then((result) => result.data),

  // Same error handling strategy as setup — see comment above.
  disable: (data) =>
    axios(`${_endpoint}/disable`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data,
    })
      .then((result) => result.data)
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 400 || status === 422) {
          throw err;
        }
        apiHelper.handleError(err);
      }),
};
